module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_innlandet_pos.7b05bb58.svg";